module.exports = __webpack_public_path__ + "img/provider_details_banner.dcb9455f.png";